import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { BRAND, LOGO, waLink } from "@/lib/brand";

export const SiteFooter = () => (
  <footer id="contatti" className="bg-[#082535] text-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-10">
      <div>
        <div className="inline-block bg-[#FAF8F5] rounded-2xl px-4 py-3">
          <img src={LOGO} alt={BRAND.name} className="h-10 w-auto" />
        </div>
        <p className="text-sm text-white/70 mt-5 max-w-xs leading-relaxed">
          Pronti a intervenire per prenderci cura del tuo animale domestico, con tutto il rispetto che merita.
        </p>
      </div>
      <div className="space-y-4 text-sm">
        <p className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Contatti</p>
        <p className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#D4AF37]" /> {BRAND.address}</p>
        <a href={BRAND.phoneHref} className="flex gap-3 hover:text-[#F4E8C1]" data-testid="footer-phone"><Phone className="h-4 w-4 mt-0.5 text-[#D4AF37]" /> {BRAND.phone}</a>
        <a href={`mailto:${BRAND.email}`} className="flex gap-3 hover:text-[#F4E8C1]"><Mail className="h-4 w-4 mt-0.5 text-[#D4AF37]" /> {BRAND.email}</a>
        <a href={waLink(BRAND.wa, "Buongiorno, vorrei informazioni.")} target="_blank" rel="noopener noreferrer" className="flex gap-3 hover:text-[#F4E8C1]" data-testid="footer-whatsapp">
          <MessageCircle className="h-4 w-4 mt-0.5 text-[#25D366]" /> Scrivici su WhatsApp
        </a>
      </div>
      <div className="space-y-4 text-sm">
        <p className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Area riservata</p>
        <p className="text-white/70">Veterinari convenzionati: accedi per prenotare i ritiri e scaricare i documenti di trasporto.</p>
        <Link to="/login" data-testid="footer-login-link" className="inline-flex rounded-full border border-[#D4AF37]/60 px-5 py-2 font-semibold hover:bg-[#D4AF37] hover:text-[#082535] transition-colors">
          Accedi
        </Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
      © {new Date().getFullYear()} {BRAND.name} · Roma e provincia
    </div>
  </footer>
);
